/**
 * A date the Brief states — when it fielded, when a version was written — as a reader says it. In
 * UTC, so the dates a Brief states do not move with the reader's clock.
 */
const BRIEF_DATE = new Intl.DateTimeFormat(undefined, {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
});

export const briefDate = (iso: string): string => BRIEF_DATE.format(new Date(iso));
